import { render, staticRenderFns } from "./CAxAFAxClarificationsPage.vue?vue&type=template&id=477a62b8"
import script from "./CAxAFAxClarificationsPage.vue?vue&type=script&lang=js"
export * from "./CAxAFAxClarificationsPage.vue?vue&type=script&lang=js"
import style0 from "./CAxAFAxClarificationsPage.vue?vue&type=style&index=0&id=477a62b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports